import throttle from 'lodash/throttle';
export default class NavigationBar {
    constructor() {
        this.navigationBarSelector = '[data-navigation-bar]';
        this.navigationBarItemTargetLocations = [];
        this.manuallyScrolled = false;
        this.classes = {
            fixed: 'fixed',
            active: 'active',
            close: 'close'
        };
        this.events = {
            click: 'click',
            scroll: 'scroll',
            DOMContentLoaded: 'DOMContentLoaded'
        };
        document.addEventListener(this.events.DOMContentLoaded, () => {
            this.init();
        });
    }

    init() {
        const navigationBar = document.querySelector(this.navigationBarSelector);
        if (navigationBar === null) {
            return false;
        }
        const closeNavigationBarButton = navigationBar.querySelector(`.${this.classes.close}`);
        closeNavigationBarButton.addEventListener(this.events.click, () => {
            navigationBar.style.display = 'none';
        });
        const navigationBarItems = navigationBar.querySelectorAll('a');
        const self = this;
        navigationBarItems.forEach((element) => {
            const itemTargetLocation = element.getAttribute('data-href');
            if (itemTargetLocation !== null) {
                self.navigationBarItemTargetLocations.push(itemTargetLocation);
                element.addEventListener(self.events.click, (event) => {
                    document.querySelector(self.navigationBarSelector).querySelector(`.${this.classes.active}`).classList.remove(self.classes.active);
                    event.currentTarget.classList.add(self.classes.active);
                    self.manuallyScrolled = true;
                    const targetElementPosition = document.querySelector(itemTargetLocation).getBoundingClientRect();
                    window.scroll(0, window.pageYOffset + targetElementPosition.top - 150);
                });
            }
        });
        self.navigationBarBreakingPoint = navigationBar.getBoundingClientRect().top + window.pageYOffset - 150;
        document.addEventListener(self.events.scroll, throttle(self.updateNavigation.bind(self), 100));
        self.updateNavigation();
    }

    updateNavigation() {
        this.stickNavigationBar();
        if (this.manuallyScrolled) {
            this.manuallyScrolled = false;
            return;
        }
        this.updateNavigationItem();
    }

    stickNavigationBar() {
        const navigationBar = document.querySelector(this.navigationBarSelector);
        const scrollPosition = window.pageYOffset;
        if (scrollPosition > this.navigationBarBreakingPoint && !navigationBar.classList.contains(this.classes.fixed)) {
            navigationBar.classList.add(this.classes.fixed);
        } else if (scrollPosition <= this.navigationBarBreakingPoint && navigationBar.classList.contains(this.classes.fixed)) {
            navigationBar.classList.remove(this.classes.fixed);
        }
    }

    updateNavigationItem() {
        for (const item of this.navigationBarItemTargetLocations) {
            const section = document.querySelector(item);
            if (section !== null) {
                const sectionRect = section.closest('div').getBoundingClientRect();
                const navigationBarItemRect = document.querySelector(`[data-href="${item}"]`).getBoundingClientRect();
                if (sectionRect.top < navigationBarItemRect.top && sectionRect.bottom > navigationBarItemRect.top) {
                    document.querySelector(this.navigationBarSelector).querySelector(`.${this.classes.active}`).classList.remove(this.classes.active);
                    document.querySelector(`[data-href="${item}"]`).classList.add(this.classes.active);
                }
            }
        }
    }
}
